/* eslint-disable no-param-reassign */
import React, { useEffect, useCallback } from 'react';
import classNames from 'classnames';

import classes from './styles.module.scss';

let animationId;

function isChromiumBased() {
  const ua = navigator.userAgent;
  const hasChromeObject = !!window.chrome; // window.chrome is usually defined in Chromium‐based browsers

  const chromiaRegex = /(Chrome|Chromium|Edg\/|OPR\/|Vivaldi|Brave)/i;
  const matchesUA = chromiaRegex.test(ua);

  const isBrave =
    typeof navigator.brave === 'object' &&
    typeof navigator.brave.isBrave === 'function';

  return (hasChromeObject && matchesUA) || isBrave;
}

export default function Progress({
  isDraggingProgressBar,
  progressBarRef,
  mouseDownHandler,
  videoSectionPlayerRef,
  videoProgress,
  animateProgressBar,
  onRewind,
  secondaryVideoRef,
}) {
  const progressBarHandler = useCallback(
    (event) => {
      const zoom = isChromiumBased()
        ? getComputedStyle(document.documentElement)
            .getPropertyValue('--zoom')
            .trim()
        : 1;

      const progressBar = progressBarRef.current;
      const clickPosition =
        event.clientX / zoom - progressBar.getBoundingClientRect().left / zoom;

      const progressBarWidth = progressBar.offsetWidth;
      const percentage = clickPosition / progressBarWidth;
      const currentTime = percentage * videoSectionPlayerRef.current?.duration;

      if (onRewind) {
        onRewind(currentTime);
      }

      videoSectionPlayerRef.current.currentTime = currentTime;

      if (secondaryVideoRef?.current) {
        secondaryVideoRef.current.currentTime = currentTime;
      }

      animateProgressBar();
    },
    [
      animateProgressBar,
      onRewind,
      progressBarRef,
      secondaryVideoRef,
      videoSectionPlayerRef,
    ]
  );

  const stopAnimation = () => {
    cancelAnimationFrame(animationId);
  };

  useEffect(() => {
    return () => {
      stopAnimation();
    };
  }, [animateProgressBar, videoSectionPlayerRef]);

  return (
    <div
      className={classes.Progress}
      onMouseDown={mouseDownHandler}
      onClick={(event) => {
        progressBarHandler(event);
        event.stopPropagation();
      }}
    >
      <div
        className={classNames(
          classes.progressBar,
          isDraggingProgressBar && classes.dragging
        )}
        ref={progressBarRef}
      >
        <div
          className={classes.progress}
          style={{
            width: `${videoProgress}%`,
          }}
        />
      </div>
    </div>
  );
}
